import { isClient } from "../../utils/functions"

let lottieWeb = {};

if (isClient()) {
  lottieWeb = require('lottie-web');
  lottieWeb.setQuality('low');
}

export default lottieWeb;